import { Component, input, output, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommunityItem, FeedType } from '../../../../interfaces';
import { AppPlatformService } from '../../../../services/app-platform.service';
import { DataTestDirective } from '@outlaw/core';
import { ExternalLinkDirective } from '../../../../directives/external-link.directive';
import { IconComponent, IconName } from '@outlaw/icons';

@Component({
  selector: 'app-post-social-link',
  templateUrl: './post-social-link.component.html',
  styleUrls: ['./post-social-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DataTestDirective, ExternalLinkDirective, IconComponent],
})
export class PostSocialLinkComponent {
  item = input.required<CommunityItem>();
  sourceLogo = input.required<IconName | ''>();
  logoAlign = input<string>();
  feedType = input<FeedType>(FeedType.user);
  isMajiApp = input<boolean>(false);
  socialClick = output<string>();

  private postSocialService = inject(AppPlatformService);

  socialMediaUrl = computed<string>(() => this.postSocialService.getSocialMediaUrl(this.item()));

  iconName = computed<IconName | null>(() => {
    const logo = this.sourceLogo();
    return logo || null;
  });

  logoSize = computed(() => {
    return this.postSocialService.getSourceLogoSize(this.item());
  });

  onSocialClick() {
    this.socialClick.emit(this.socialMediaUrl());
  }
}
